import React from "react";
import Aboutstyle from "./Aboutstyle.css";


const aboutStyle = {
    mx: 'auto',
    color: '#457b9d',
    marginBottom: '40px'
}

export default function About() {

    return(

<section id="About">
<div style={aboutStyle}>
    <h2 id="name">hello there</h2>

<div style={{color: 'black'}} id="infoblock">
<h3 style={aboutStyle}>I'm Michelle!</h3>
<p>Hello, I'm currently a first-year at UCLA majoring in Computer Science and Linguistics. This website is 
    still a work in progress, 
    so be sure to check back and see new changes every week!

    Currently, I am learning about websites, apps, backends, servers,and games, with much more to come. 
    </p> 
    </div>
</div>
<hr></hr>


</section>

    );
}